  import { Form,Rate } from "antd";
  import moment from "moment";
  import "moment/locale/vi";
  import React, { useState } from "react";


  import ReactHtmlParser from "react-html-parser";
  import { Button, Container, Row } from "reactstrap";
  import {
    BigPlayButton,
    ClosedCaptionButton,
    ControlBar,
    CurrentTimeDisplay,
    ForwardControl,
    Player,
    ReplayControl,
  } from "video-react";
  import FooterModal from "../../FooterModal";
  import TitleQuestion from "../../TitleQuestion";
  import HintBox from "../../Utilities/HintBox";
  import Circle, { calculateResultCircle } from "./Circle";
  import StarModal from "./StarModal";
  import Write, { calculateResultWrite, toFormValues } from "./Write";
  import GuideModal from "../../GuideModal/GuideModal";
  import styles from "./styles.module.css";
  import RateStar from "./Rate";
  moment.locale("vi");

  function Circle_Write(props) {
    const isTuLuan = props.isTuLuan || false;
    const [rating,setRating] = React.useState(0)
    const isHello = props.isHello;
    const [form] = Form.useForm();
    const [state, setState] = React.useState({
      booleanArray: [],
      isPointed: false,
      isDisabledRetry: true,
      isDisabledSubmit: true,
      autoPlay: false,
      countStudentAnswer: 0,
    });
    const [Question, setQuestion] = React.useState(null);
    const [modalStar, setModalStar] = React.useState(false);
    const [countStudentAnswer, setCountStudentAnswer] = React.useState(0); // đếm số lần trả lời sai
    const handleChangeValueRate =(value)=>{
      setRating(value)
    }
    //
    React.useEffect(() => {
      const clonedProps = JSON.parse(JSON.stringify(props));
      const autoPlay = props.autoPlay;
      const question = clonedProps.question;
      //initialCircle
      question.Circle.isDoing = true;
      question.Circle.userAnswers = Array.from(question.Circle.initialValue);
      //initialWrite
      question.Write.isDoing = true;
      question.Write.userAnswers = Array.from(question.Write.initialValue);
      form.resetFields();
      // form.setFieldsValue(toFormValues(question.Write.userAnswers)); // nhập giá trị cho form
      //
      const audioUrl = clonedProps.audio;
      const videoUrl = clonedProps.video;
      //update
      setState((prevState) => ({ ...prevState, audioUrl, videoUrl, autoPlay }));
      setQuestion(question);
    }, [form, props]);
    // hiển thị ngôi sao
    const onModalStar = () => {
      setModalStar(true);
      setTimeout(() => {
        setModalStar(false);
      }, 3000);
    };
    //
    const onSubmit = React.useCallback(() => {
      const { Circle, Write } = Question;
      //Circle
      Circle.isDoing = false; //

      Circle.resultCircle = calculateResultCircle(
        Circle.userAnswers,
        Circle.answers,
        Circle.listWords,
        Circle.limitSelect
      );
      //Write
      Write.isDoing = false; //
      const values = form.getFieldsValue();
      Write.userAnswers = Object.values(values);
      Write.resultWrite = calculateResultWrite(
        Write.userAnswers,
        Write.answers,
        Write.checkUppercase
      );
      //State
      const ArrayCircle =  Circle.resultCircle.booleanArray;
      const ArrayWrite =  Write.resultWrite.booleanArray
      const { star, resultString, percent, booleanArray } = calculateResult(
        ArrayCircle,
        ArrayWrite
      );
      star >= 4 ? setCountStudentAnswer(pre => pre + 2) : setCountStudentAnswer(pre => pre + 1)
      const studentAnswer = {
        Write: Write.userAnswers,
        Circle: Circle.userAnswers,
      };
      const params = {
        score: percent,
        unit: props.unit,
        results: resultString,
        exerciseId: props.id,
        sreatedDate: moment().format(),
        studentAnswer: JSON.stringify(studentAnswer),
      };
      if (isTuLuan) {
        const audio = new Audio("/Audios/5.mp3");
        audio.play();
      }
      props.postAnswerToApi(params);
      //update
      setState((pre) => ({
        ...pre,
        isDisabledRetry: false,
        isDisabledSubmit: true,
        booleanArray,
        star,
        percent
      }));
      setQuestion((pre) => ({ ...pre, Circle, Write }));
      onModalStar();
    }, [Question, form, props]);

    const onRetry = React.useCallback(() => {
      const { Circle, Write } = Question;
      const resultCircleArray = Circle.userAnswers.filter(value => Circle.answers.includes(value));
      //initialCircle
      const resultWrite = Write.userAnswers.map((element, index) => (Write.answers[index] === element ? element : ''));

      console.log(Write.userAnswers);
      console.log(resultWrite);
        
      Circle.isDoing = true; //
      Circle.userAnswers = Array.from(resultCircleArray);
      //initialWrite
      Write.isDoing = true;
      Write.userAnswers = Array.from(resultWrite);
      form.resetFields();
      form.setFieldsValue(toFormValues(Write.userAnswers)); // nhập giá trị cho form
      //initialState
      const booleanArray = [];
      //update
      setState((pre) => ({ ...pre, booleanArray, isDisabledRetry: true }));
      setQuestion((pre) => ({ ...pre, Circle, Write }));
    }, [Question, form]);
    
    const transform = React.useCallback(
      (node, index) => {
        if (
          node.type === "tag" &&
          node.name === "input" &&
          (node.attribs.type === "Circle" || node.attribs.type === "Underline")
        ) {
          //render tag input Circle
          const id_circle = node.attribs.id;

          return (
            <Circle
              key={index}
              id={id_circle}
              data={Question.Circle}
              isHello={isHello}
              setData={(data) => setQuestion((pre) => ({ ...pre, Circle: data }))}
              type={node.attribs.type}
            />
          );
        }
        if (node.type === "tag" && node.name === "hintbox") {
          const { id } = node.attribs;
          return props.hintBox.map((v, i) => {
            if (id !== `${i}`) return null;
            const { src, borderColor, width, position, arrow } = v;
            return (
              <HintBox
                key={i}
                src={src}
                borderColor={borderColor}
                width={width}
                position={position}
                arrow={arrow}
               />
            );
          });
        }
        
        if (node.type === "tag" && node.name === "textarea") {
          //render tag textarea
          //<div><textarea id="0" rows="7" text-indent='200px' color='red'  margin-top='500px' ></textarea></div>
          const { id, rows, ...elementStyle } = node.attribs;
          const { textareaStyle } = props;
          const isCorrect = Question.Write.resultWrite?.listBoolean[id] ?? false;
        if(Question.Write.isDoing === false){
          isCorrect === true || isHello ? textareaStyle.color = '#2ecc71' : textareaStyle.color = '#e74c3c'
        }else{textareaStyle.color = 'black'}
          
          return (
            <div key={index}>
              <Form.Item name={id} initialValue={node.children[0]?.data}>
                <textarea
                  rows={rows}
                  className={styles.notes}
                  style={{
                    fontSize: 24,
                    // height:40,
                    border: "none",
                    ...props.textareaStyle,
                    ...elementStyle,
                  }}
                ></textarea>
              </Form.Item>
            </div>
          );
        }
        
        if (node.type === "tag" && node.name === "input") {
          //render tag input
          
          const { id, type, rows, ...elementStyle } = node.attribs;
          
          
          return (
            <Write
              key={index}
              id={id}
              data={Question.Write}
              type={type}
              isHello={isHello}
              rows={rows}
              elementStyle={elementStyle}
            />
          );
        }
      },
      [Question]
    );
    //
    const checkEnableSubmit = React.useCallback(() => {
      //
      setQuestion((question) => {
        //check Write
        const formValues = form.getFieldsValue();
        const isWriteDone = Object.values(formValues).every((item) => item);
        //check Circle
        const { Circle } = question;
        const isCircleDone = Circle.userAnswers.length >= Circle.answers.length;
        const isSubmit = isWriteDone && isCircleDone;
        //
        setState((pre) => ({ ...pre, isDisabledSubmit: !isSubmit }));
        return question;
      });
    }, [form]);
    //
    const renderContent = React.useCallback(() => {
      const { Layout } = Question;
      return (
        <div
          style={{ fontSize: 24, marginBottom: 50 }}
          onClick={checkEnableSubmit}
        >
          {ReactHtmlParser(Layout, { transform })}
        </div>
      );
    }, [Question, checkEnableSubmit, transform]);
    //
    if (!Question) return null;

    return (
      <Container>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <div>
            <Row>
              <TitleQuestion titleQuestion={props.titleQuestion} />
              
            </Row>
            {state.videoUrl && (
              <div class="d-flex justify-content-center" style={props.videoStyle}>
                <div style={{ width: "35vw", marginBottom: 50 }}>
                  <Player>
                    <BigPlayButton position="center" />
                    <source src={props.video} type="video/mp4" default />

                    <track
                      kind="captions"
                      src={props.videoSub}
                      srcLang="en"
                      label="English"
                    />
                    <ControlBar autoHide={false}>
                      <ReplayControl seconds={10} order={1.1} />
                      <ForwardControl seconds={10} order={1.2} />
                      <CurrentTimeDisplay order={4.1} />
                      <ClosedCaptionButton order={7} />
                    </ControlBar>
                  </Player>
                </div>
              </div>
            )}
            <Row
              style={{
                display: "flex",
                justifyContent: "start",
                alignItems: "start",
              }}
            >
              <Form
                autoComplete="off"
                form={form}
                // onFinish={onFinish}
                onValuesChange={checkEnableSubmit}
              >
                {renderContent()}
              </Form>
              
            </Row>
            <Row>
                {props.RateStar ? (
                  <RateStar
                  handleChangeValueRate={handleChangeValueRate}
                  countStar={props.RateStar.countStar}
                  style={props.RateStar.style}
                  styleFonts={props.RateStar.styleFonts}
                  styleColor={props.RateStar.styleColor}
                  defaultValue={props.RateStar.defaultValue}
                  />
                ) : (
                  <React.Fragment />
                )}
              </Row>
            {!isTuLuan && (<StarModal isModal={modalStar} star={state.star} />)}
          </div>
        </div>
        
        {/* ẩn button trả lời câu hỏi */}
        
        {/* {testButton({ Question, setQuestion, form })}  */}
        <FooterModal
          onRetry={onRetry}
          onSubmit={onSubmit}
          audioUrl={state.audioUrl}
          autoPlay={state.autoPlay}
          result={state?.booleanArray}
          starCircle={state?.percent}
          studentAnswer={state.studentAnswer}
          exerciseKey={props.exerciseKey}
          isDisabledRetry={state.isDisabledRetry}
          isDisabledSubmit={state.isDisabledSubmit}
          hideBtnFooter={props.hideBtnFooter} //not answer
          guideModal={props.guideModal}
          isTuLuan={isTuLuan}
          newWords={props.newWords}
          countStudentAnswer={countStudentAnswer}
        />
      </Container>
    );
  }

  export default Circle_Write;

  function calculateResult(ArrayCircle, ArrayWrite) {
   
    const booleanArray = ArrayWrite.length > 0 ? [ArrayCircle,ArrayWrite] : [ArrayCircle]
    const correctAnswerCircle = ArrayCircle.filter((x) => x === true).length;
    const correctArrayWrite = ArrayWrite.filter((x) => x === true).length;
    const ThongSoCircle = correctAnswerCircle/ArrayCircle.length;
    const ThongSoWrite = ArrayWrite.length > 0 ? correctArrayWrite/ArrayWrite.length : 0;
    const percent = ArrayWrite.length > ArrayCircle.length ? parseInt(((ThongSoCircle*4 + ThongSoWrite*6)/(booleanArray.length*5))*100) : parseInt(((ThongSoCircle + ThongSoWrite)/booleanArray.length)*100)
    const star = percent / 20; 
    const resultString = `${percent/100}`;
    
    return { star, resultString,booleanArray, percent };
  }

  // test
  function testButton({ Question, setQuestion, form }) {
    return (
      <div>
        <Button
          onClick={() => {
            setQuestion((pre) => {
              const { Circle, Write } = pre;
              Circle.userAnswers = Array.from(Circle.answers);
              //
              Write.userAnswers = Array.from(Write.answers);
              // form.resetFields();
              form.setFieldsValue(toFormValues(Write.userAnswers)); // nhập giá trị cho form
              return { ...pre, Circle, Write };
            });
          }}
        >
          điền đáp án test
        </Button>
        <Button
          onClick={() => {
            console.log("🚀 ~ Circle.userAnswers: ", Question.Circle.userAnswers);
            const values = form.getFieldsValue();
            const Write_userAnswers = Object.values(values);
            console.log("🚀 ~ Write_userAnswers", Write_userAnswers);
          }}
        >
          log userAnswers
        </Button>
      </div>
    );
  }
  
